export default __webpack_public_path__ + "static/media/platinum3.b5800162.svg";